import React from 'react';
import TextWrapPhoto from '../Photos/TextWrapPhoto';
import './Chapters.scss';
//import photo1 from "../../assets/inline-textwrap1.png";
//edit url below or delete below if importing photo above.
import photo1 from '../../Assets/wrapPhoto1.jpg';

function Chapter2() {
  const photoData = {
    imgSrc: photo1,
    caption:
      'The technology to create manipulated media is readily accessible in 2022—and the danger it poses is real. Intel has created the first real-time deepfake detection technology, which uses FakeCatcher with a 96% accuracy rate.',
    float: 'right', //pass in "right" or "left"
    type: 'letter'
  };

  return (
    <section className="chapter">
      <p className="chapter__title">The Spread of Deepfakes</p>

      <div>
        <TextWrapPhoto photoData={photoData} />
        <p className="chapter__paragraph">
          The software to create deepfakes has been around for close to a decade, but only recently
          has it become widespread enough for just about anyone to use, rather than solely the tool
          of experts and scientists. Hyper-realistic audio and video recordings are created using
          artificial intelligence and “deep” learning methods to make deepfakes. Although the
          technology behind synthetic media is complex, actually creating a deepfake is not as
          difficult as you might think. Dr. Ciftci says it’s downright easy.
        </p>
        <p className="chapter__paragraph">
          “I know some high school students who can do it without any problem, without any
          background research,” he says. Some websites can create deepfakes using just photos, and
          there are apps and even filters on social media that can create synthetic media. “With
          mobile phones and websites, you don't even need powerful hardware,” Dr. Ciftci says. The
          process is now streamlined, with AI systems doing the work once required by experts.
        </p>
      </div>
    </section>
  );
}

export default Chapter2;
